(function () {
  const root = document.getElementById('fadewell-pdp');
  if (!root) return;

  function selectTier(tier) {
    const index = tier.dataset.t;
    root.querySelectorAll('.alv-offer').forEach((offer) => {
      const chosen = offer.querySelector('.alv-item[data-t="' + index + '"]');
      if (!chosen) return;
      offer.querySelectorAll('.alv-item').forEach((item) => {
        const selected = item === chosen;
        item.classList.toggle('selected', selected);
        item.setAttribute('aria-checked', String(selected));
      });
      const button = offer.querySelector('.alv-atc2');
      if (!button) return;
      button.dataset.vid = chosen.dataset.vid;
      const price = chosen.querySelector('.alv-vprice');
      const compare = chosen.querySelector('.alv-vcompare');
      const shownPrice = button.querySelector('.alv-atc-p');
      const shownCompare = button.querySelector('.alv-atc-s');
      if (shownPrice && price) shownPrice.textContent = price.textContent.trim();
      if (shownCompare && compare) shownCompare.textContent = compare.textContent.trim();
    });
  }

  root.querySelectorAll('.alv-item').forEach((tier) => {
    tier.addEventListener('click', () => selectTier(tier));
    tier.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        selectTier(tier);
      }
    });
  });

  async function openCartDrawer() {
    const response = await fetch('/?sections=cart-drawer-section', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Drawer refresh failed: ' + response.status);
    const sections = await response.json();
    const html = sections['cart-drawer-section'];
    if (!html) throw new Error('Cart drawer section missing');
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const replacement = doc.querySelector('#cart-drawer');
    const current = document.querySelector('#cart-drawer');
    if (!replacement || !current) throw new Error('Cart drawer element missing');
    current.replaceWith(replacement);
    await customElements.whenDefined('theme-drawer');
    replacement.open();
  }

  root.querySelectorAll('.alv-atc2').forEach((button) => {
    button.addEventListener('click', async (event) => {
      event.preventDefault();
      const id = Number(button.dataset.vid);
      if (!Number.isSafeInteger(id)) return;
      const before = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1, ...(Number(root.dataset.sellingPlanId) ? { selling_plan: Number(root.dataset.sellingPlanId) } : {}) }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || 'Add to cart failed');
        await openCartDrawer();
      } catch (error) {
        button.textContent = error.message || 'Unable to add to cart';
        setTimeout(() => { button.innerHTML = before; }, 4000);
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });
})();
